module.exports = __webpack_public_path__ + "img/xuanchuan.31615630.png";